import router from '@/router'
import { useAppointmentManagementStore } from '@/store/practitioner-public-profile/appointmentManagementStore'
import { usePractitionerPublicProfileStore } from '@/store/practitioner-public-profile/practitionerPublicProfileStore'
import { Address } from '@/store/search-page/mainSearchBarStore.d'

/**
 *
 * @param nextAvailability
 * @param selectedAddress
 * @param mainDiscipline - slug discipline
 * @param city
 * @param practitionerSlug - slug
 * @param scrollToForm
 * @param appointmentReasonId
 * @param remote
 */
export async function goToProfile(
  nextAvailability: string,
  selectedAddress: Address,
  mainDiscipline: string,
  city: string,
  practitionerSlug: string,
  scrollToForm: boolean,
  appointmentReasonId: string = '',
  remote: 'in-person' | 'remote' | null = null,
) {
  const practitionerPublicProfileStore = usePractitionerPublicProfileStore()
  const appointmentManagementStore = useAppointmentManagementStore()
  // practitionerPublicProfileStore.profile comes after going in profil page so we put this nextAvailability in the store to use it after
  practitionerPublicProfileStore.nextAvailability = nextAvailability
  appointmentManagementStore.selectedAddress = {
    ...selectedAddress,
    remote: selectedAddress.remote ?? false,
  }
  if (remote) {
    appointmentManagementStore.remote = remote
  }
  practitionerPublicProfileStore.distanceFromPatient = selectedAddress.hint

  const query = {} as any
  query.appointmentReasonId = appointmentReasonId
  query.addressId = selectedAddress.id
  appointmentManagementStore.selectedReasonId = appointmentReasonId

  if (remote) {
    query.remote = remote
  }

  if (scrollToForm) {
    query.scrollToForm = 'true'
  }

  await router.push({
    name: 'PractitionerPublicProfile',
    params: {
      discipline: mainDiscipline,
      city,
      practitionerSlug,
    },
    query,
  })
}
